export default __webpack_public_path__ + "static/media/057-emergency diversion.e4fc4c07.png";